import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConfirmDeleteDialog = ({ open, onOpenChange, title, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="confirm-delete-dialog" className="max-w-[calc(100vw-2rem)] rounded-2xl bg-[#FDFBF7] sm:max-w-md">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-serif text-2xl text-[#2C2A28]">Delete this memory permanently?</AlertDialogTitle>
        <AlertDialogDescription className="text-sm leading-relaxed text-[#4A4540]">
          “{title}” and any Memory Insight saved with it will be permanently deleted. This cannot be undone.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter className="gap-2">
        <AlertDialogCancel data-testid="confirm-delete-cancel" className="rounded-full border-[#2C2A28]/20 bg-white text-[#2C2A28] hover:bg-[#F4EFE6]">Keep my memory</AlertDialogCancel>
        <AlertDialogAction data-testid="confirm-delete-yes" onClick={onConfirm} className="rounded-full bg-[#B4412F] text-white hover:bg-[#9a3627]">
          Yes, delete permanently
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
